import { leaf, split } from './paneTreeModel';

/**
 * Built-in layout shapes. Each `build(ids)` takes exactly `slots` pane ids
 * (reading order) and returns a tree. Applying a preset keeps the tab's
 * running panes and assigns them to the leaves in reading order (store
 * `applyPreset`); extra leaves get the default shell.
 */
export const LAYOUT_PRESETS = [
  {
    id: 'twoCols',
    labelKey: 'terminalExt.presetTwoCols',
    label: '2 columns',
    slots: 2,
    build: ([a, b]) => split('row', leaf(a), leaf(b)),
  },
  {
    id: 'twoRows',
    labelKey: 'terminalExt.presetTwoRows',
    label: '2 rows',
    slots: 2,
    build: ([a, b]) => split('col', leaf(a), leaf(b)),
  },
  {
    id: 'grid',
    labelKey: 'terminalExt.presetGrid',
    label: '2×2 grid',
    slots: 4,
    build: ([a, b, c, d]) =>
      split('row', split('col', leaf(a), leaf(c)), split('col', leaf(b), leaf(d))),
  },
  {
    id: 'mainSide',
    labelKey: 'terminalExt.presetMainSide',
    label: 'Main + side stack',
    slots: 3,
    build: ([a, b, c]) => split('row', leaf(a), split('col', leaf(b), leaf(c)), 0.6),
  },
  {
    id: 'threeCols',
    labelKey: 'terminalExt.presetThreeCols',
    label: '3 columns',
    slots: 3,
    build: ([a, b, c]) => split('row', leaf(a), split('row', leaf(b), leaf(c)), 1 / 3),
  },
];

export const presetById = (id) => LAYOUT_PRESETS.find((p) => p.id === id) || null;
